// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tickets-list[data-v-787072cb] {\n  padding: 20px 30px;\n  list-style-type: none;\n}\n.ticket[data-v-787072cb] {\n  width: 100%;\n  margin: 5px 0;\n  padding: 10px;\n  border-radius: 4px;\n  background-color: #c9c9cc;\n}\n.ticket[data-v-787072cb]:nth-child(even) {\n  background-color: #f4f5f7;\n}\n", ""]);
// Exports
module.exports = exports;
